// extracted by mini-css-extract-plugin
export default {"stripeLabel":"PaymentType_stripeLabel__wyUYl"};